export default __webpack_public_path__ + "static/cps-b6be553c23d691f93cc83c467d336606.png";